<template>
  <div class="weather-item grid-item" :style="{ color, borderColor: color }">
    <div class="day">{{ day }}</div>
    <div class="weather-icon">
      <img :src="require(`@/assets/svg/day/${currentCode}.svg`)" />
    </div>
    <div class="temp-max">{{ max }}</div>
    <div class="temp-min">{{ min }}</div>
    <div class="tile-desc">{{ currentDesc }}</div>
  </div>
</template>

<script>
export default {
  name: "WeatherItem",
  props: ["date", "max", "min", "code", "desc"],
  computed: {
    color() {
      return "#" + (this.$route.params.color || "FFFFFF");
    },
    currentCode() {
      let cc = new Date().getHours();

      if (this.day !== "Today") {
        return this.code[12].weatherCode;
      } else return this.code[cc].weatherCode;
    },
    currentDesc() {
      let cc = new Date().getHours();

      if (this.day !== "Today") {
        return this.code[12].weatherDesc[0].value;
      } else return this.code[cc].weatherDesc[0].value;
    },
    day() {
      let date = new Date().getDate();
      let wdate = new Date(this.date).getDate();
      let wday = new Date(this.date).getDay();
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      if (!(date - wdate)) {
        return "Today";
      } else if (wdate - date === 1) {
        return "Tomorrow";
      } else {
        return days[wday];
      }
    }
  }
};
</script>

<style>
.panels-grid .weather-item {
  text-align: center;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.weather-item .day {
  font-weight: bold;
  margin:auto;
  font-size: 26px;
}

.weather-item .weather-icon {
  width:69px;
  height: 53px;
  margin: 0 auto auto auto;
}

.weather-item .weather-icon img {
  max-width: 100%;
}

.weather-item .temp-max {
  font-weight: bold;
  font-size: 110px;
  align-items: center;
  height: 110px;

}

.weather-item .temp-min {
  font-size: 46px;
  font-weight: bold;
  margin-bottom:  5px;
  height: 46px;
}
.tile-desc {
    display:none;
  position: absolute;
  opacity: 0.02;
  bottom: 1px;
}
</style>
